import { ListItemIcon, ListItemText, MenuItem } from '@mui/material';

import { AvailableTenant } from '../../types';
import { TenantIcon } from './styled';

interface TenantOptionProps {
    tenant: AvailableTenant;
    onTenantChange: (tenant: AvailableTenant) => void;
}

export default function TenantOption({ tenant, onTenantChange }: TenantOptionProps) {
    return (
        <MenuItem onClick={ () => onTenantChange(tenant) } >
            <ListItemIcon>
                <TenantIcon src={ tenant.logoMarkUri } 
                    alt={ tenant.name }>
                </TenantIcon>
            </ListItemIcon>
            <ListItemText>{ tenant.name }</ListItemText>
        </MenuItem>
    );
}
